"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDictionaryRowStyle = exports.dictionarySubtitle = exports.dictionaryActionbarFactory = void 0;
const react_1 = __importDefault(require("react"));
const colors_1 = require("@material-ui/core/colors");
const dictionary_actionbar_1 = require("./dictionary-actionbar");
/**
 * Helper to create INVALIDATE / REVALIDATE actionbar.
 */
function dictionaryActionbarFactory(options) {
    return function ActionBar() {
        return react_1.default.createElement(dictionary_actionbar_1.DictionaryActionbar, { ...options });
    };
}
exports.dictionaryActionbarFactory = dictionaryActionbarFactory;
/**
 * Default dictionary subtitle helper.
 */
function dictionarySubtitle(value) {
    var _a;
    return (_a = value === null || value === void 0 ? void 0 : value.name) !== null && _a !== void 0 ? _a : '';
}
exports.dictionarySubtitle = dictionarySubtitle;
/**
 * Default createRowStyle function = grey inactive items.
 */
function createDictionaryRowStyle(value) {
    return !value.active
        ? {
            color: colors_1.grey[400],
        }
        : {};
}
exports.createDictionaryRowStyle = createDictionaryRowStyle;
//# sourceMappingURL=dictionary-utils.js.map